import { render, staticRenderFns } from "./WorkerBrigades.vue?vue&type=template&id=368c8466&"
import script from "./WorkerBrigades.vue?vue&type=script&lang=js&"
export * from "./WorkerBrigades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports